export const supportsTouchEvents = (): boolean => {
  if (typeof window === "undefined") return false;

  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    ("msMaxTouchPoints" in navigator &&
      (navigator as Navigator & { msMaxTouchPoints: number }).msMaxTouchPoints >
        0)
  );
};

export const isTouchDevice = (): boolean => {
  return (
    supportsTouchEvents() &&
    typeof window !== "undefined" &&
    (navigator.maxTouchPoints > 1 ||
      "ontouchstart" in window ||
      (window.matchMedia && window.matchMedia("(pointer: coarse)").matches))
  );
};
